export class MentionsConstants {
  static readonly charactersAfterAtSignRegex = new RegExp(/(?<=[@]).*/);
}
